import React, { ChangeEvent } from 'react'

import { useReactiveVar } from '@apollo/client'
import classNames from 'classnames'

import { CommonFilterOptionIcon } from '@local/assets/icons'

import Clickable from '@web/components/Clickable'
import { ReviewGroupsMediaFilter, UserReviewGroupsSort } from '@web/gql/graphql'
import usePageInfo from '@web/hooks/usePageInfo'
import nClicks from '@web/libs/nlog/click/codes'
import sendClickLog from '@web/libs/nlog/click/sendClickLog'

import styles from './MediaFilter.module.scss'
import { reviewTabFilterStateVar } from '../../filter.state'

type Props = {
  mediaFilter: ReviewGroupsMediaFilter
  setMediaFilter: (mediaFilter: ReviewGroupsMediaFilter) => void
}

const MediaFilter = ({ mediaFilter, setMediaFilter }: Props) => {
  const { isMyPage } = usePageInfo()
  const clickCodeArea = isMyPage ? nClicks.reviewTab : nClicks.reviewTabOthers

  const sort = useReactiveVar(reviewTabFilterStateVar.sort)

  const handleMediaFilter = (mediaFilter: ReviewGroupsMediaFilter) => {
    setMediaFilter(mediaFilter)
    reviewTabFilterStateVar.mediaFilter(mediaFilter)

    reviewTabFilterStateVar.placeCategoryId(undefined)
    reviewTabFilterStateVar.regionCode(undefined)
  }

  const toggleReviewGroupsMediaFilter = (e: ChangeEvent) => {
    if (mediaFilter === ReviewGroupsMediaFilter.WithMedia) {
      handleMediaFilter(ReviewGroupsMediaFilter.All)
      sendClickLog({ event: e, area: clickCodeArea.ALL })
      return
    }

    handleMediaFilter(ReviewGroupsMediaFilter.WithMedia)
    sendClickLog({ event: e, area: clickCodeArea.PHOTO })
  }

  return (
    <div className={styles.filter_area}>
      <div className={styles.sort_area}>
        <Clickable
          className={styles.sort}
          aria-selected={sort === UserReviewGroupsSort.VisitDateTimeDesc}
          onClick={() => reviewTabFilterStateVar.sort(UserReviewGroupsSort.VisitDateTimeDesc)}
          nClickCode={clickCodeArea.NEW}
        >
          최신순
        </Clickable>
        <Clickable
          className={styles.sort}
          aria-selected={sort === UserReviewGroupsSort.ViewCountDesc}
          onClick={() => reviewTabFilterStateVar.sort(UserReviewGroupsSort.ViewCountDesc)}
          nClickCode={clickCodeArea.VIEW}
        >
          조회수순
        </Clickable>
      </div>
      <div className={styles.input_area}>
        <input
          type="checkbox"
          id="onlyHasMedia"
          className={classNames('place_blind', styles.input_checkbox)}
          onChange={toggleReviewGroupsMediaFilter}
          checked={mediaFilter === ReviewGroupsMediaFilter.WithMedia}
        />
        <label htmlFor="onlyHasMedia" className={styles.input_label}>
          <CommonFilterOptionIcon className={styles.icon} aria-hidden="true" />
          사진/영상 리뷰만
        </label>
      </div>
    </div>
  )
}

export default MediaFilter
